<template>
  <div class="mt-5">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 col-lg-10">
          <div class="card">
            <div class="d-flex">
              <h3 class="font-weight-light ml-3 mr-auto">Comprovante de Pagamento</h3>
              <WhiteLabel class="ml-auto mt-1 pull-right mr-4">
                <router-link :to="{ name: 'bills-payment' }">
                  <i class="icon-arrow-left-circle"></i> Voltar
                </router-link>
              </WhiteLabel>
            </div>
            <hr />
            <div class="card-content">
              <div class="form-row col-12">
                <div class="col-12 col-w-full">
                  <WhiteLabel>
                    <h4 class="font-weight-light blue"> {{ getTitle() }} </h4>
                  </WhiteLabel>
                </div>
                <div class="form-group col-12 col-lg-12 mb-4">
                  <label>Agente arrecadador</label>
                  <p>CNC: 341 Banco Itaú S/A</p>
                </div>
                <div v-if="showRevenueCode()" class="form-group col-12 col-lg-6 mb-4">
                  <label>Código de Receita</label>
                  <p>{{ getValueOf('RevenueCode') }}</p>
                </div>
                <div v-if="showDocumentNumber()" class="form-group col-12 col-lg-6 mb-4">
                  <label>Número do documento</label>
                  <p>{{ getValueOf('DocumentNumber') }}</p>
                </div>
                <div v-if="'0428' == this.getAgreementCode()" class="form-group col-12 col-lg-6 mb-4">
                  <label> Data de Vencimento </label>
                  <p>{{ paymentDetail.dueDate | moment('DD/MM/YYYY')}}</p>
                </div>
                <div v-if="'0025' == this.getAgreementCode()" class="form-group col-12 col-lg-6 mb-4">
                  <label> Código do município </label>
                  <p>{{ getValueOf('CityCode') }}</p>
                </div>
                <div v-if="'0025' == this.getAgreementCode() && ('679-8' == getValueOf('RevenueCode') || '035-8' == getValueOf('RevenueCode')) " class="form-group col-12 col-lg-6 mb-4">
                  <label> Número AIIM </label>
                  <p>{{ getValueOf('AiimNumber') }}</p>
                </div>
                <div v-if="'0025' == this.getAgreementCode()" class="form-group col-12 col-lg-6 mb-4">
                  <label> Exercício </label>
                  <p>{{ getValueOf('CompetencePeriod') }}</p>
                </div>
                <div class="form-group col-12 col-w-full col-lg-6 col-xl-6 mb-4">
                  <label>Valor</label>
                  <p>
                    {{
                      paymentDetail.value
                        | currency('R$ ', 2, {
                            decimalSeparator: ',',
                            thousandsSeparator: '.',
                          })
                    }}
                  </p>
                </div>
                <div class="form-group col-12 col-lg-12 mb-4">
                  <label>Código de Barras</label>
                  <p>{{ getBarcodeFormat() }}</p>
                </div>
                <div class="form-group col-12 col-lg-6 mb-4">
                  <label> Autenticação </label>
                  <p>{{ getValueOf('OperationCode') }}</p>
                </div>
                <div class="form-group col-12 col-lg-6 mb-4">
                  <label></label>
                  <p>Comprovante de pagamento emitido de acordo com a Portaria CAT 126, de 16/09/2011, e autorizado pelo Processo 13840-1112955-2016</p>
                </div>
                <div class="form-group col-12 col-lg-6 mb-4">
                  <label>Data do pagamento</label>
                  <p>{{ paymentDetail.createdAt | moment('DD/MM/YYYY HH:mm:ss') }}</p>
                </div>
                 <div class="form-group col-12 col-lg-6 mb-4">
                  <label>Via</label>
                  <p>Internet</p>
                </div>
                <div class="form-group col-12 col-lg-6 mb-4">
                  <label>NSU</label>
                  <p>{{ getValueOf('Nsu') }}</p>
                </div>
                <div class="form-group col-12">
                  <label class="text-muted">
                    RECEBIDO POR CORRESPONDENTE BANCÁRIO DIGITAL E PROCESSADO POR ITAÚ UNIBANCO S.A.
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import paymentDetailsCommonMethods from './paymentDetailsCommonMethods.js';

export default {
  name: 'AppPaymentDetailsTypeSEFAZ',
  mixins: [paymentDetailsCommonMethods],
  props: {
    paymentDetail: {
      type: Object,
      required: true,
      validator(value) {
        return (
          value &&
          typeof value.barCode === 'string' &&
          'valuePaid' in value &&
          'preset' in value
        );
      },
    },
  },
  methods: {
    getTitle() {
      const agreementCode = this.getAgreementCode();
      const billType = this.agreementCodeType();

      if(agreementCode == '0185') return 'Comprovante de Pagamento DARE-SP/GNRE - SEFAZ/SP via Contribuinte';
      if(agreementCode == '0428') return 'Comprovante de Pagamento GARE ICMS PEP SEFAZ/SP via Contribuinte';
      if(billType == 'IPVA') return 'Comprovante de Pagamento - GARE IPVA - SEFAZ/SP via Contribuinte';

      return '';
    },
    getBarcodeFormat() {
      const agreementCode = this.getAgreementCode();

      if (agreementCode === '0428' || agreementCode === '0025') {
        return this.formatBarcodeForSEFAZ(this.paymentDetail.barCode);
      }

      return this.formatStringInFourParts(this.paymentDetail.barCode);
    },
  },
};
</script>
